import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationComponent } from './notification/notification.component';

export interface QuestionType {
  value: any;
  label: string;
  cls?: string;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  askDurationInSeconds = 20 * 10;
  errorDurationInSeconds = 15;
  successDurationInSeconds = 5;

  constructor(private snackBar: MatSnackBar) { }

  onServerGet(error: any) {
    this.showErrors([
      'Fehler bei Serveranfrage.',
      'Sind Sie mit Internet verbunden?'
    ]);
  }

  onServerPost(error: any) {
    this.showErrors([
      'Fehler bei Serveranfrage.',
      'Sind Sie mit Internet verbunden?'
    ]);
  }

  askQuestion(title: string, messages: string[], buttons: QuestionType[], action?: any) {
    this.snackBar.openFromComponent(NotificationComponent, {
      duration: this.askDurationInSeconds * 1000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: 'notification-snackbar-panel',
      data: {
        type: 'question',
        title,
        messages,
        buttons,
        action
      }
    });
    //console.error('ERRORS:',errors);
  }

  showErrors(errors: any[]) {
    this.snackBar.openFromComponent(NotificationComponent, {
      duration: this.errorDurationInSeconds * 1000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      data: {
        type: 'error',
        errors
      }
    });
    //console.error('ERRORS:',errors);
  }

  showSuccess(msg: string, messages: any[] = [], errors: any[] = []) {

    this.snackBar.openFromComponent(NotificationComponent, {
      duration: this.successDurationInSeconds * 1000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      data: {
        type: 'success',
        msg,
        messages,
        errors
      }
    });
  }
}
